export default __webpack_public_path__ + "static/media/531613989115-4.4ae05b38.png";